(function () {
  if (window.__cartUpsellsGlobalInstalled) return;
  window.__cartUpsellsGlobalInstalled = true;

  function getErrorElement(button) {
    var card = button.closest('[data-cart-upsell]');

    return card
      ? card.querySelector('[data-cart-upsell-error]')
      : null;
  }

  function resetButton(button, originalHTML, originalLabel) {
    if (!document.body.contains(button)) return;

    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = originalHTML;

    if (originalLabel) {
      button.setAttribute('aria-label', originalLabel);
    }
  }

  async function addUpsell(button) {
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');

    if (!variantId) {
      console.error('[Cart upsell] Missing variant ID.');
      return;
    }

    var originalHTML = button.innerHTML;
    var originalLabel = button.getAttribute('aria-label');
    var errorElement = getErrorElement(button);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = '...';

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    var formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', '1');

    /*
     * Request the exact cart sections Shapes needs to
     * redraw the drawer and update its internal cart state.
     */
    formData.append(
      'sections',
      'cart-items,cart-footer,cart-item-count,cart-live-region'
    );

    formData.append(
      'sections_url',
      window.location.pathname
    );

    try {
      var response = await fetch(
        window.theme && window.theme.routes
          ? window.theme.routes.cart_add_url
          : '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        }
      );

      var data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this item.'
        );
      }

      /*
       * Tell Shapes to redraw:
       * - cart line items
       * - subtotal/footer
       * - native cart state
       * - live region
       *
       * Because the drawer is already open, it should remain open.
       */
      document.body.dispatchEvent(
        new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: data,
            sourceId: null
          }
        })
      );

      /*
       * Your custom nav counter now listens to the same
       * Shapes events, so it will update from this event too.
       */

      if (document.body.contains(button)) {
        button.textContent = '✓';
        button.removeAttribute('aria-busy');

        if (originalLabel) {
          button.setAttribute(
            'aria-label',
            originalLabel.replace(/^Add /i, 'Added ')
          );
        }

        setTimeout(function () {
          resetButton(
            button,
            originalHTML,
            originalLabel
          );
        }, 1000);
      }

    } catch (error) {
      console.error('[Cart upsell]', error);

      resetButton(
        button,
        originalHTML,
        originalLabel
      );

      if (errorElement && document.body.contains(errorElement)) {
        errorElement.textContent =
          error.message || 'Unable to add this item.';

        errorElement.hidden = false;
      }
    }
  }

  /*
   * Event delegation is intentional.
   *
   * Shapes can completely replace the cart HTML.
   * Because this listener lives on document, newly rendered
   * upsell buttons continue working automatically.
   */
  document.addEventListener(
    'click',
    function (event) {
      var addButton =
        event.target.closest('[data-cart-upsell-add]');

      if (addButton) {
        event.preventDefault();
        event.stopPropagation();

        addUpsell(addButton);
        return;
      }

      var previousButton =
        event.target.closest('[data-cart-upsells-prev]');

      if (previousButton) {
        event.preventDefault();

        var previousSection =
          previousButton.closest('[data-cart-upsells]');

        var previousTrack = previousSection
          ? previousSection.querySelector(
              '[data-cart-upsells-track]'
            )
          : null;

        if (previousTrack) {
          previousTrack.scrollBy({
            left: -previousTrack.clientWidth * 0.75,
            behavior: 'smooth'
          });
        }

        return;
      }

      var nextButton =
        event.target.closest('[data-cart-upsells-next]');

      if (nextButton) {
        event.preventDefault();

        var nextSection =
          nextButton.closest('[data-cart-upsells]');

        var nextTrack = nextSection
          ? nextSection.querySelector(
              '[data-cart-upsells-track]'
            )
          : null;

        if (nextTrack) {
          nextTrack.scrollBy({
            left: nextTrack.clientWidth * 0.75,
            behavior: 'smooth'
          });
        }
      }
    },
    true
  );
})();